export default "__VITE_ASSET__yyueLDxw__"